export enum ServiceTargetEnum {
  Personal = "personal",
  Family = "family",
}
